<template>
  <v-data-table
    :headers="headers"
    :items="brandingCodes"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="BrandingCode-button-new"
          @click="$router.push({
            name: 'processing-EditBrandingCode'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'processing-EditBrandingCode',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListBrandingCode',
  module: 'BrandingCode',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('brandingCodes', ['brandingCodes']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('brandingCode'),
          value: 'code',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_brandingCodes();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('brandingCodes', ['LOAD_brandingCodes', 'DELETE_brandingCode']),
    /** Delete BrandingCode from the collection
     */
    async remove(BrandingCode) {
      this.isLoading = true;
      await this.DELETE_BrandingCode(BrandingCode);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# BrandingCode example

'''js
<BrandingCode />
'''
</docs>
